import { Component, Input } from '@angular/core';

import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'icon',
  templateUrl: './icon.component.html',
  imports: [TranslocoPipe],
})
export class IconComponent {
  @Input() type!: string;
}
